<!-- Search Input and Filters -->
<app-filters *appHasPermission="'get_update_details'" [filters]="filterStructure"> </app-filters>

<!-- table skeleton loader -->
 @if (isFetchingApprovalList$ | async) {
<div class="mt-[0.94rem]">
  <app-table-skeleton-loader></app-table-skeleton-loader>
</div>
}

<!-- Client Table -->
@if (!(isFetchingApprovalList$ | async)) {
  <div
    *appHasPermission="'get_update_details'"
    class="mt-[0.94rem] rounded-lg border border-solid border-gray-200 bg-white"
  >
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <div
          class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
        >
          <table class="min-w-full leading-normal">
            <thead>
              <tr>
                <th
                  class="flex border-b-2 border-gray-200 bg-gray-100 px-5 py-4 text-left text-xs font-semibold text-gray-600"
                >
                  S/N
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M7.99998 3.33301V12.6663M7.99998 12.6663L12.6666 7.99967M7.99998 12.6663L3.33331 7.99967"
                      stroke="#667085"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
                >
                  Date Requested
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
                >
                  Account Name
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
                >
                  Maker
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
                >
                  Checker
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              @for (
                approval of approvalList$ | async;
                track approval.id;
                let i = $index
              ) {
                <tr>
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p>{{ i + 1 }}</p>
                  </td>
                  <td
                    class="cursor-pointer border-b border-gray-200 bg-white px-5 py-5 text-sm"
                    (click)="viewUpdateDetails(approval)"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ approval.created_at | date: 'medium' }}
                    </p>
                  </td>
                  <td
                    class="cursor-pointer border-b border-gray-200 bg-white px-5 py-5 text-sm"
                    (click)="viewUpdateDetails(approval)"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ formatAccountName(approval.account_name) || '-' }}
                    </p>
                  </td>
                  <td
                    class="cursor-pointer border-b border-gray-200 bg-white px-5 py-5 text-sm"
                    (click)="viewUpdateDetails(approval)"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ approval.edited_by || '-' }}
                    </p>
                  </td>

                  <td
                    class="cursor-pointer border-b border-gray-200 bg-white px-2 py-2 text-xs sm:px-3 sm:py-3 sm:text-sm md:px-4 md:py-4 lg:px-5"
                    (click)="viewUpdateDetails(approval)"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ approval.approved_by || '-' }}
                    </p>
                  </td>
                  <td
                    class="cursor-pointer gap-2 border-b border-gray-200 bg-white px-5 py-5 text-sm"
                    (click)="viewUpdateDetails(approval)"
                  >
                    <span
                      class="relative inline-block px-2 py-1 font-semibold leading-tight text-green-900 sm:px-2"
                    >
                      <span
                        aria-hidden
                        class="absolute inset-0 {{
                          approval.status === 'approved'
                            ? 'bg-green-200'
                          : approval.status === 'pending'
                            ? 'bg-orange-300'
                            : 'bg-red-300'
                        }} opacity-50 rounded-full"
                      ></span>
                      <span
                        class="relative flex  {{
                          approval.status === 'approved'
                            ? 'text-[#027A48]'
                          : approval.status === 'pending'
                            ? 'text-orange-900'
                            : 'text-red-700'
                        }} sm:text-[11px]"
                      >
                        {{ approval.status | uppercase }}</span
                      >
                    </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <app-table-navigator
            *ngIf="totalCount$ | async as totalCount"
            [total]="totalCount"
            (onNavigation)="navigate($event)"
          ></app-table-navigator>
        </div>
      </div>
    </div>
  </div>
}